export default __webpack_public_path__ + "static/media/7.bc5e153d.jpg";